import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { UpdatesInbox } from '~/components/updates/updates-inbox'
import { titleFor } from '~/lib/route-title'

/**
 * The notification feed, as a page of its own.
 *
 * It was a third tab on Home for a release, which put it in two places at
 * once: the icon rail's bell already pointed at a destination, and a bell
 * that opens a tab of another page is a bell nobody trusts.
 */
export const Route = createFileRoute('/_authenticated/$workspaceSlug/updates')({
  component: UpdatesInbox,
  head: () => ({ meta: [{ title: titleFor(msg`Updates`) }] }),
})
